module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hotsite-dgc', [_c('div', {
    staticClass: "conteudo"
  }, [_c('bloco', {
    staticClass: "-nomargin -softpadding -fullheight",
    attrs: {
      "id": "dgc_orientacoes"
    }
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar -upper"
  }, [_vm._v("Orientações e Manuais")])], 1), _c('div', {
    staticClass: "texto",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v("Aqui você encontra as orientações e manuais para download")]), _c('mensagem', {
    staticClass: "-warn"
  }, [_c('p', [_vm._v("Nenhuma orientação ou manual foi encontrada no momento")])])], 1), _c('footer', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('back-and-share')], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08fdbc0b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/dgc/Orientacoes.vue
// module id = 450
// module chunks = 0